import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";
import { useFilteredValues } from "components/Filters/hooks/useFilteredValues";
import FilteredValuesLoader from "components/Loaders/FilteredValuesLoader";

import SingleFilteredValue from "./SingleFilteredValue";

const FilteredValues = () => {
    const { gray200, gray900 } = colors;

    const { isLoading, filteredValues, handleDelete, handleClearAll } =
        useFilteredValues();

    const { t } = useTranslation();

    const renderContent = () => {
        if (isLoading) {
            return <FilteredValuesLoader />;
        }

        return filteredValues.length > 0 ? (
            <div
                css={css({
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    columnGap: "6px",
                    rowGap: "6px",
                    borderTop: `1px solid ${gray200}`,
                    padding: "7px 24px 8px 24px"
                })}
            >
                <div
                    css={css({
                        color: gray900,
                        fontSize: "14px",
                        fontWeight: "500",
                        lineHeight: "36px",
                        letterSpacing: "0.1px",
                        marginRight: "10px"
                    })}
                >{`${t("Filter##filtered by")}:`}</div>

                {filteredValues.map(({ filterName, value }) => (
                    <SingleFilteredValue
                        key={filterName}
                        filterName={filterName}
                        value={value}
                        handleDelete={handleDelete}
                    />
                ))}

                <Button
                    color={BUTTON_COLORS.White}
                    size={BUTTON_SIZES.Small}
                    variant={BUTTON_VARIANTS.TextOnly}
                    onClick={handleClearAll}
                >
                    {t("Button##clear all")}
                </Button>
            </div>
        ) : null;
    };

    return renderContent();
};

export default FilteredValues;
